<template>
    <!-- <div v-if="this.$connectivity"> -->
        <main>
            <HeaderTab :title="$t('horse.titre.creer')" :icon="['fal', 'horse']" />
            <div id="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            
                            <div v-if="addingHorse" class="text-center my-5">
                                <h5>{{ isMareContext ? $t('horse.creation_jument_en_cours') : $t('horse.creation_cheval_en_cours') }}</h5>
                                <LoadingSpinner class="mt-3" />
                            </div>

                            <form v-else>
                                
                                <div class="form-group" v-if="all_tiers.length > 1">
                                    <label>{{ $t('horse.nom_proprietaire') }}<sup>*</sup></label>
                                    
                                    <e-select
                                    id="tiers"
                                    track-by="tiers_id"
                                    label="tiers_rs"
                                    :options="all_tiers"
                                    :searchable="true"
                                    :show-labels="false"
                                    :placeholder="$t('monte.selectionner_tiers')"
                                    v-model="tiers_selected"
                                    >
                                    <template slot="option" slot-scope="{ option }">{{ option.tiers_rs }}</template>
                                    <template slot="singleLabel" slot-scope="{ option }">{{ option.tiers_rs }}</template>
                                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                                </e-select>
                            </div>
                            
                            <!-- Nom -->
                            <div class="form-group">
                                <label>{{ $t('horse.form.nom') }}<sup>*</sup></label>
                                
                                <div class="input-group">
                                    <input class="form-control" type="text" :placeholder="$t('horse.form.nom')" v-model="horse_nom" id="horse_nom" @keyup="checkHorseName" :class="{ 'is-invalid': error_name }" required>
                                </div>
                            </div>
                            
                            <!-- Sexe -->
                            <div class="form-group">
                                <label>{{ $t('horse.form.sexe') }}<sup>*</sup></label>
                                <e-select
                                v-model="horse_sexe"
                                id="sexe_code"
                                track-by="sexe_code"
                                label="sexe_label"
                                :placeholder="$t('horse.placeholder.sexe')"
                                :selectedLabel="$t('select.selectedLabel')"
                                :options="horse_sexes"
                                :searchable="true"
                                :allow-empty="false"
                                :loading="isLoadingHorseSexe"
                                :show-labels="false"
                                :disabled="isMareContext"
                                >
                                <template slot="first" slot-scope="{ option }">{{ option.label }}</template>
                                <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                            </e-select>
                        </div>
                        
                        <!-- Robe -->
                        <div class="form-group">
                            <label>{{ $t('horse.form.robe') }}<sup>*</sup></label>
                            <e-select
                            v-model="horse_robe"
                            id="robe_code"
                            track-by="robe_code"
                            label="robe_label"
                            :placeholder="$t('horse.placeholder.robe')"
                            :selectedLabel="$t('select.selectedLabel')"
                            :options="horse_robes"
                            :searchable="true"
                            :allow-empty="false"
                            :loading="isLoadingHorseRobe"
                            :show-labels="false"
                            >
                            <template slot="first" slot-scope="{ option }">{{ option.label }}</template>
                            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                        </e-select>
                    </div>
                    <!-- Race -->
                    <div class="form-group">
                        <label>{{ $t('horse.form.race') }}<sup>*</sup></label>
                        <e-select
                        v-model="horse_race"
                        id="race_code"
                        track-by="race_code"
                        label="display_label"
                        :placeholder="$t('horse.placeholder.race')"
                        :selectedLabel="$t('select.selectedLabel')"
                        :options="horse_races"
                        :searchable="true"
                        :allow-empty="false"
                        :loading="isLoadingHorseRace"
                        :show-labels="false"
                        >
                        <template slot="first" slot-scope="{ option }">{{ option.label }}</template>
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
                </div>
                
                <!-- Date de naissance -->
                <div class="form-group">
                    <label>{{ $t('horse.form.datenaissance') }}<sup>*</sup></label>
                    <div class="input-group">
                        <e-datepicker v-model="horse_datenaissance" />
                        <div class="input-group-append">
                            <span class="input-group-text"><font-awesome-icon :icon="['fal', 'calendar-alt']" /></span>
                        </div>
                    </div>
                </div>
                
                <div class="form-group">
                    <label>{{ $t('horse.pere') }}</label>
                    <input class="form-control" type="text" :placeholder="$t('horse.pere')" :value="horse_pere" @input="horse_pere = $event.target.value.toUpperCase()" id="horse_pere" style="text-transform: uppercase;">
                </div>
                
                <div class="form-group">
                    <label>{{ $t('horse.mere') }}</label>
                    <input class="form-control" type="text" :placeholder="$t('horse.mere')" :value="horse_mere" @input="horse_mere = $event.target.value.toUpperCase()" id="horse_mere" style="text-transform: uppercase;">
                </div>
                
                <!-- Message d'erreur si besoin -->
                <ErrorAlert v-if="message_erreur_code !== ''" :messageI18n="message_erreur_code" />
                
                <!-- Bouton de validation du formulaire -->
                <div class="text-center mt-5">
                    <button type="submit" v-on:click.prevent="checkForm" class="btn btn-primary" :disabled="error_name">
                        {{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus-circle']"/>
                    </button>
                </div>
            </form>
            
        </div>
    </div>
</div>
</div>

<b-modal ref="add_parent" hide-footer size="xl">
    <template v-if="parent_sexe == 'F'" v-slot:modal-title>
        {{ $t("horse.confirmation_mere") }}
    </template>
    <template v-else-if="parent_sexe == 'M'" v-slot:modal-title>
        {{ $t("horse.confirmation_pere") }}
    </template>
    
    <HorseAjout :horse_sexe="parent_sexe" :horse_name="parent_name" :close.sync="close_modal" :horse_selected.sync="parent_selected" />
</b-modal>
</main>
</template>

<script type="text/javascript">
import { EventBus } from 'EventBus';

import ConfigMixin from '@/mixins/Config';
import HorseMixin from '@/mixins/Horse';
import Tools from '@/mixins/Tools';
import _isEmpty from 'lodash/isEmpty'
import _cloneDeep from 'lodash/cloneDeep'
import UserMixin from "@/mixins/User.js"

export default {
    name: "HorseCreation",
    mixins: [ConfigMixin, HorseMixin, Tools, UserMixin],
    data () {
        return {
            horsePere: {},
            horseMere: {},
            sexeM: ['Mâle', 'Hongre'],
            sexeF: ['Femelle'],
            horse_races: [],
            horse_robes: [],
            horse_sexes: [],
            
            horse_nom: null,
            horse_race: null,
            horse_robe: null,
            horse_sexe: null,
            horse_datenaissance: null,
            
            required_values: [
            'horse_nom',
            'horse_race',
            'horse_sexe',
            'horse_robe',
            'horse_datenaissance'
            ],
            message_erreur_code: '',
            isLoadingHorseSexe: true,
            isLoadingHorseRobe: true,
            isLoadingHorseRace: true,
            addingHorse : false,
            error_name: false,
            all_tiers: [],
            tiers_selected: null,
            parent_sexe: '',
            parent_name: '',
            horse_pere: '',
            horse_mere: '',
            close_modal: false,
            parent_selected: null,
            pere: null,
            mere: null
        }
    },
    computed: {
        isMareContext() {
            return this.$route.query.from === 'mare' || this.$route.query.from === 'contract'
        }
    },
    mounted() {
        this.init_component()
    },
    methods: {
        async init_component() {
            this.horse_robes = await this.getRobes()
            let horse_sexes = await this.getSexes()
            let horse_races = await this.getRaces()
            const config_sexe = this.getConfigHorseSexes()
            const config_race = this.getConfigHorseRaces()
            
            if(config_sexe.length > 0) {
                horse_sexes = horse_sexes.filter(sexe => config_sexe.includes(sexe.sexe_code))
            }
            if(config_race.length > 0) {
                horse_races = horse_races.filter(race => config_race.includes(race.race_code))
            }
            this.horse_sexes = horse_sexes
            this.horse_races = horse_races
            this.horse_races = this.horse_races.map((race) => {
                race.display_label = this.$t("race." + race.race_code) +' / '+ race.race_label
                return race
            })
            if(this.isMareContext) {
                this.horse_sexe = this.horse_sexes.find(s => s.sexe_code === 'F')
            }
            else if(this.horse_sexes.length == 1) {
                this.horse_sexe = this.horse_sexes[0]
            }
            
            this.isLoadingHorseSexe = false
            this.isLoadingHorseRobe = false
            this.isLoadingHorseRace = false
            
            this.horse_robe = this.horse_robes.find(robe => robe.robe_code === 'UKN')
            this.horse_race = this.horse_races.find(race => race.race_code === 'UKN')
            
            this.all_tiers = this.getConfig('all_tiers')
            if(this.all_tiers.length == 1) {
                this.tiers_selected = this.all_tiers[0]
            }
            
            if(this.$route.query.horse_nom) {
                this.horse_nom = this.$route.query.horse_nom
            }
            else if(this.$route.params.value) {
                this.horse_nom = this.$route.params.value
            }
        },
        
        async validForm() {
            if(!this.addingHorse){
                this.addingHorse = true
                
                let params = {
                    horse_nom: this.horse_nom,
                    horse_sexe: this.horse_sexe.sexe_code,
                    horse_robe: this.horse_robe.robe_code,
                    horse_race: this.horse_race.race_code,
                    horse_datenaissance: this.horse_datenaissance,
                    dam: this.mere,
                    sire: this.pere,
                    type: 'manuel',
                    tiers_id: this.tiers_selected.tiers_id
                }
                let retour = await this.addHorseManuel(params)
                if(retour.retour) {
                    const horse_id = retour.retour.horse_id
                    // Retour vers ContractNew avec étalon + jument pré-remplis si on vient du formulaire de contrat
                    if(this.$route.query.from === 'contract') {
                        const params = { mare_id: horse_id }
                        if(this.$route.query.stallion_id) params.stallion_id = this.$route.query.stallion_id
                        if(this.$route.query.tiers_id) params.tiers_id = this.$route.query.tiers_id
                        this.$router.push({ name: 'ContractNew', params })
                    } else {
                        this.$router.push({ name: 'horseFiche', params: { horse_id }})
                    }
                }
                this.addingHorse= false
            }   
        },
        
        checkForm() {
            let el = ''
            let error = false
            
            // On vérifie chaque input obligatoire
            for(let i=0; i<this.required_values.length; i++) {
                el = this.required_values[i]
                
                // On ajoute la classe error sur les div des v-model non remplis
                if(this[el] === null || this[el] === undefined) {
                    error = true
                }
            }
            
            if(!this.tiers_selected) {
                error = true
            }
            
            if(error) {
                this.message_erreur_code = "formulaire.erreur_champs_non_remplis"
            }
            else {
                this.message_erreur_code = ""
                this.checkParent('M')
            }
        },
        
        checkParent(sexe) {
            if(sexe == 'M') {
                if(this.horse_pere) {
                    this.openModalParent('M')
                }
                else {
                    this.checkParent('F')
                }
            }
            if(sexe == 'F') {
                if(this.horse_mere) {
                    this.openModalParent('F')
                }
                else {
                    this.validForm()
                }
            }
        },
        
        openModalParent(sexe) {
            this.parent_sexe = sexe
            if(sexe == 'M') this.parent_name = _cloneDeep(this.horse_pere)
            if(sexe == 'F') this.parent_name = _cloneDeep(this.horse_mere)
            this.$refs.add_parent.show()
        },
        
        checkHorseName() {
            this.error_name = false
            this.horse_nom = this.accentsTidy(this.horse_nom).toUpperCase()
            if(_isEmpty(this.horse_nom) || !/^[^!"`#%&,:;<>=@{}~$()*+/?[\]^|]+$/.test(this.horse_nom)) {
                this.error_name = true
            }
        },
        
        selectParent(val) {
            if(this.parent_sexe == 'M') {
                this.pere = val
                this.horse_pere = val.nom +', '+ val.codeRace +', '+ val.codeRobe
                this.checkParent('F')
            }
            else if(this.parent_sexe == 'F') {
                this.mere = val
                this.horse_mere = val.nom +', '+ val.codeRace +', '+ val.codeRobe
                this.validForm()
            }
        }
    },
    watch: {
        close_modal() {
            this.$refs.add_parent.hide()
            if(this.parent_sexe == 'M') {
                this.checkParent('F')
            }
            else if(this.parent_sexe == 'F') {
                this.validForm()
            }
        },
        parent_selected(val) {
            if(val) {
                this.$refs.add_parent.hide()
                this.selectParent(val)
            }
        }
    },
    components: {
        HeaderTab: () => import('@/components/HeaderTab'),
        LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
        ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
        HorseAjout: () => import('@/components/Horse/HorseAjout')
    }
};
</script>
